<p-confirmDialog #sendNotificationCD [style]="{width: 'fit-content', paddingBottom : '1%'}"
                 header="Send notification to watchers"
                 key="sendNotificationCD">
  <ng-template pTemplate="footer">
    <button (click)="sendNotificationCD.accept()" class="btn btn-outline-primary button-size pull-right" type="reset">
      <i aria-hidden="true" class="fa fa-paper-plane pr-2"></i>
      Save and send notification to watchers
    </button>
    <button (click)="sendNotificationCD.reject()" class="btn btn-outline-info button-size pull-right" type="reset">
      Save and don't send notification to watchers
    </button>
    <button (click)="sendNotificationCD.hide()" class="btn btn-outline-secondary button-size pull-right" type="reset">
      Cancel
    </button>
    <br>
  </ng-template>
</p-confirmDialog>
<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a routerLink="/document">Documents</a>
          </li>
          <li *ngIf="modeEdit || modeRead" aria-current="page" class="breadcrumb-item active">{{ document?.title }}</li>
          <li *ngIf="modeCreate" aria-current="page" class="breadcrumb-item active">New</li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div *ngIf="!loading">
        <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
          {{ errorMessage }}
          <button (click)="error = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="success" class="alert alert-success alert-dismissible fade show">
          {{ successMessage }}
          <button (click)="success = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="successSendNotification && modeRead" class="alert alert-success alert-dismissible fade show">
          Selected users are notified of the new uploaded document successfully.
          <button (click)="successSendNotification = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div>
          <div class="pb-2 mb-3 border-bottom">
            <h3 *ngIf="modeRead"><b>{{ document.title }}</b></h3>
            <h3 *ngIf="modeEdit"><b>Edit {{ document.title }}</b></h3>
            <h3 *ngIf="modeCreate"><b>Upload document</b></h3>
          </div>
          <form #documentForm="ngForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="onSubmit(documentForm)"
                class="row">
            <div class="col-6 col-md-12 col-lg-6">
              <div class="form-group margin-bottom-5">
                <label class="control-label col-12 font-weight-bolder">Available to:
                  <small *ngIf="selectedCompanies.length===0 && selectedLabels.length===0" class="error-text">
                    (Make sure to choose at least one affiliation or one client.)
                  </small>
                </label>
                <div class="col-9 pt-1">
                  <div *ngFor="let lab of labelsItems" class="custom-control custom-checkbox margin-bottom-10">
                    <p-checkbox #label="ngModel" [(ngModel)]="selectedLabels" [disabled]="modeRead"
                                label={{lab.label}} name="label{{lab.value}}"
                                value={{lab.value}}></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="form-group margin-bottom-5 row col-12">
                <label class="control-label col-3 font-weight-bolder pt-2">Available to clients:</label>
                <div *ngIf="modeCreate || modeEdit" class="col-9 no-padding">
                  <p-multiSelect [(ngModel)]="selectedCompanies"
                                 [disabled]="selectedLabels.length === 3" [options]="companiesItems"
                                 [style]="{'width':'100%'}" placeholder="Select companies" filter="true"
                                 name="availableToClients" optionLabel="label">
                  </p-multiSelect>
                </div>
                <div *ngIf="modeRead" class="col-9 pt-2">
                    <span *ngFor="let company of selectedCompaniesLabels; let i=index ;let last=last">
                      <span *ngIf="selectedCompaniesLabels.length < 10 || document.deleted" class="hellip-format">
                        <span *ngIf="!last">{{ company }}, </span>
                        <span *ngIf="last">{{ company }}</span>
                      </span>
                      <span *ngIf="selectedCompaniesLabels.length >= 10 && !document.deleted" class="hellip-format">
                        <span *ngIf="i<9">{{ company }}, </span>
                        <span *ngIf="i===9 && last">{{ company }} </span>
                        <span *ngIf="i===9 && !last">{{ company }}, </span>
                        <span *ngIf="i===10" class="hellip-format">&hellip;</span>
                      </span>
                    </span>
                </div>
              </div>
              <div class="row pt-3">
                <div class="col-11">
                </div>
                <div class="col-1">
                  <button (click)="clearFile()" *ngIf="modeCreate || modeEdit" pTooltip="Clear file"
                          class="btn btn-outline-info fa fa-remove clear-button" type="button">
                  </button>
                </div>
              </div>
              <div *ngIf="modeCreate || modeEdit" class="form-group col-12 margin-bottom-5">
                <div class="row pt-2">
                  <div class="col-12">
                    <div class="p-0 align-content-center center ">
                      <div (dragleave)="dragLeaveHandler($event)" (dragover)="dragOverHandler($event)"
                           (drop)="dropHandler($event)">

                        <p-fileUpload #fileUpload (onSelect)="onFileSelected($event)" [showUploadButton]="true"
                                      [style]="{'margin':'auto','background-color': 'transparent','color':'#000000'}"
                                      [chooseLabel]="dropAndDropPlaceholder"
                                      class="drag-box"
                                      customUpload="true"
                                      fileLimit=1
                                      id="fileUpload" mode="basic" name="file" ngDefaultControl>
                        </p-fileUpload>
                      </div>
                    </div>
                    <span *ngIf="maxSize" style="font-size: 11px"><b>Max size: </b> {{ maxSize }} MB</span>
                    <div>
                    <span *ngIf="!modeRead && mimeTypesDisplayed"
                          style="font-size: 11px"><b>Valid mime-types:</b> {{ mimeTypesDisplayed }}</span>
                    </div>
                    <small *ngIf="fileSizeError">
                      <p class="error-text">
                        Make sure to upload a file with max size of {{ maxSize }} MB.
                      </p>
                    </small>
                    <small *ngIf="mimeTypeError">
                      <p class="error-text">
                        The file type {{ mimeTypeInvalid }} is not valid.
                      </p>
                    </small>
                    <small *ngIf="extensionError">
                      <p class="error-text">
                        The extension {{ extensionInvalid }} is not valid.
                      </p>
                    </small>
                  </div>
                </div>
              </div>
              <div *ngIf="modeRead || modeEdit" class="form-group margin-bottom-5 pt-3 col-12 row">
                <label class="control-label col-3 font-weight-bolder">Filename:</label>
                <div class="col-9 no-padding">
                  {{ document.filename }}
                </div>
              </div>
              <div class="form-group pt-3 col-12 row">
                <label class="control-label col-3 font-weight-bolder pt-2">Document title:</label>
                <div class="col-9 no-padding">
                  <input #title="ngModel" [(ngModel)]="document.title" [disabled]="modeRead" class="width100"
                         maxlength="225"
                         name="title" pInputText type="text">
                  <div><span *ngIf="!modeRead" style="font-size: 11px">Leave empty for filename</span></div>
                  <small *ngIf="title.invalid && (documentForm.submitted || title.dirty || title.touched)">
                    <p *ngIf="title.errors?.maxlength" class="error-text">
                      Title cannot be longer than 255 characters.
                    </p>
                  </small>
                </div>
              </div>
              <div class="form-group margin-bottom-5 col-12 row">
                <label class="control-label col-3 font-weight-bolder">Tag:</label>
                <div *ngIf="!modeRead" class="col-9 no-padding">
                  <p-multiSelect [(ngModel)]="selectedTags" [options]="tagsItems"
                                 [style]="{'width':'100%'}" placeholder="Select tags"
                                 filter="true" name="tags" optionLabel="label" optionValue="value">
                  </p-multiSelect>
                </div>
                <div *ngIf="modeRead" class="col-9 no-padding">
                  <span *ngFor="let tag of selectedTags ;let last=last">
                    <span *ngIf="selectedTags.length>0" class="hellip-format">
                      <span *ngIf="!last">{{ tag.label || tag }}, </span>
                      <span *ngIf="last">{{ tag.label || tag }}</span>
                    </span>
                  </span>
                  <span *ngIf="selectedTags.length===0" class="hellip-format">No selected tags</span>
                </div>
              </div>
              <div class="form-group margin-bottom-5 row col-12 pt-3">
                <label class="control-label col-3 font-weight-bolder">Monitor downloads:</label>
                <div class="col-9 no-padding">
                  <div class="custom-checkbox">
                    <p-checkbox #monitor="ngModel" [(ngModel)]="document.monitor" [binary]="true"
                                [disabled]="modeRead" label="" name="monitor"></p-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-12 col-lg-6">
              <div class="form-group col-12">
                <label class="control-label col-12 font-weight-bolder">Roles</label>
                <div class="col-12">
                  <div *ngFor="let role of groupsItems" class="custom-control custom-checkbox margin-bottom-10">
                    <p-checkbox #group="ngModel" [(ngModel)]="selectedGroups"
                                [disabled]="modeRead || role.disabled === true"
                                label={{role.label}} name="group{{role.value}}"
                                value={{role.value}}></p-checkbox>
                    <small *ngIf="!!role.title" class="form-text text-muted" style="font-size: 13px;">
                      {{ role.title }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <div class="margin-left-5">
                <button *ngIf="modeCreate || modeEdit" [disabled]="(modeCreate && (documentForm.pristine || !uploadedNewDocument))
                      || (modeEdit && (documentForm.pristine && !uploadedNewDocument))" class="btn btn-outline-primary"
                        id="add_user_button"
                        type="submit">
                  <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>Save
                </button>
              </div>
              <div class="margin-left-5">
                <button class="btn btn-outline-secondary" id="back_to_list_documents_button" routerLink="/document"
                        type="button"><i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>Back to list
                </button>
              </div>
              <div class="margin-left-5">
                <button (click)="deleteDocument()" *ngIf="modeEdit" class="btn btn-outline-danger"
                        id="delete_document_button"
                        type="button"><i aria-hidden="true" class="fa fa-remove pr-2"></i> Delete
                </button>
              </div>

              <div class="margin-left-5">
                <button *ngIf="modeRead && !displayNotificationButton && displayNotificationNewButton"
                        class="btn btn-outline-primary"
                        routerLink="/{{getUserCurrent().company.uniqid}}/announcement/new/{{this.document.uniqid}}"
                        type="button"><i
                  aria-hidden="true" class="fa fa-send pr-2"></i> Send notification to clients
                </button>
                <button *ngIf="(modeRead || modeEdit) && displayNotificationButton"
                        [disabled]="modeEdit && (!documentForm.pristine || uploadedNewDocument)"
                        class="btn btn-outline-primary"
                        routerLink="/{{getUserCurrent().company.uniqid}}/announcement/document/{{this.document.uniqid}}"
                        type="button">
                  <i aria-hidden="true" class="fa fa-send pr-2"></i> Send notification to clients
                </button>
              </div>
              <div class="margin-left-5">
                <button (click)="onclickEdit()" *ngIf="modeRead && !document.deleted" class="btn btn-outline-success"
                        id="edit_document_button" routerLink="/document/{{document.uniqid}}/edit"
                        type="button">
                  <i aria-hidden="true" class="fa fa-edit pr-2"></i>Edit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
